import { motion } from 'framer-motion';
import { useI18n } from '../i18n/I18nContext';
import { PublicLayout } from './BookPage';
import { ShieldCheck } from 'lucide-react';

const spring = { type: 'spring', stiffness: 300, damping: 20 };
const SECTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9];

export default function PrivacyPage() {
  const { t } = useI18n();
  return (
    <PublicLayout testid="privacy-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={spring} className="max-w-3xl">
        <p className="text-or-400 font-bold tracking-widest text-sm uppercase flex items-center gap-2">
          <ShieldCheck className="w-4 h-4" strokeWidth={2.5} /> {t('privacy.eyebrow')}
        </p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-creme mt-3" data-testid="privacy-title">
          {t('privacy.title')}
        </h1>
        <p className="text-base text-brume mt-4 leading-relaxed" data-testid="privacy-intro">{t('privacy.intro')}</p>
        <div className="space-y-8 mt-10">
          {SECTIONS.map((n) => (
            <section key={n} data-testid={`privacy-section-${n}`}>
              <h2 className="text-xl font-semibold text-or-300 font-fredoka mb-2">{t(`privacy.s${n}Title`)}</h2>
              <p className="text-base text-brume leading-relaxed whitespace-pre-line">{t(`privacy.s${n}Body`)}</p>
            </section>
          ))}
        </div>
      </motion.div>
    </PublicLayout>
  );
}
